// extracted by mini-css-extract-plugin
module.exports = {"mutedGray":"#9b9b9b","navWrapper":"style-module--navWrapper--3eK6Q","brand":"style-module--brand--2DdHe","center":"style-module--center--O5lOx"};